import React, { useState, useEffect } from 'react';
import { collection, onSnapshot, doc, updateDoc, deleteDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { initializeApp, deleteApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { db } from '../firebase';
import toast from 'react-hot-toast';

const ROLES = ['admin','manager','cashier','kitchen'];
const RC = { admin:'tag-red', manager:'tag-blue', cashier:'tag-green', kitchen:'tag-amber' };
const PERM = { admin:'Full access', manager:'Billing, orders, inventory, recipes, loyalty', cashier:'Billing, orders, loyalty', kitchen:'Orders only' };

// Same config as src/firebase.js — used to create users WITHOUT logging out the admin
const firebaseConfig = {
  apiKey: "AIzaSyAQDx8wmgNa7N1E59tVC5OhvFykNPLlkP0",
  authDomain: "vip-pizza-62d4b.firebaseapp.com",
  projectId: "vip-pizza-62d4b",
  storageBucket: "vip-pizza-62d4b.firebasestorage.app",
  messagingSenderId: "715870797561",
  appId: "1:715870797561:web:e71f9b20ee1f64cd042c28",
  measurementId: "G-PFGQPLNGYC"
};

export default function Users() {
  const [users, setUsers]   = useState([]);
  const [modal, setModal]   = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm]     = useState({ name:'', email:'', password:'', role:'cashier' });

  useEffect(()=>onSnapshot(collection(db,'users'),s=>setUsers(s.docs.map(d=>({id:d.id,...d.data()})))),[]);

  const addUser=async()=>{
    if(!form.name||!form.email||!form.password){toast.error('Fill all fields');return;}
    setSaving(true);
    let secondaryApp;
    try {
      // Create a temporary secondary Firebase app instance.
      // This lets us create the new login WITHOUT logging the current admin out.
      secondaryApp = initializeApp(firebaseConfig, 'UserCreation_' + Date.now());
      const secondaryAuth = getAuth(secondaryApp);

      const { user } = await createUserWithEmailAndPassword(secondaryAuth, form.email, form.password);

      // ⚠️ CRITICAL FIX: save the profile doc with ID = user.uid
      // (previously used addDoc with a random ID, which broke role lookups)
      await setDoc(doc(db,'users', user.uid), {
        uid: user.uid, name: form.name, email: form.email,
        role: form.role, createdAt: serverTimestamp(),
      });

      await signOut(secondaryAuth);
      await deleteApp(secondaryApp);

      toast.success(`${form.name} added as ${form.role}`);
      setModal(false); setForm({name:'',email:'',password:'',role:'cashier'});
    } catch(err){
      toast.error(err.message);
      if (secondaryApp) { try { await deleteApp(secondaryApp); } catch(e){} }
    }
    setSaving(false);
  };

  const changeRole=async(id,role)=>{ await updateDoc(doc(db,'users',id),{role}); toast.success('Role updated'); };
  const removeUser=async(id,name)=>{ if(!window.confirm(`Remove ${name}?`))return; await deleteDoc(doc(db,'users',id)); toast.success('Removed'); };

  return (
    <div>
      <div className="card">
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:14 }}>
          <div className="sec-title" style={{ marginBottom:0 }}>Staff Users</div>
          <button className="btn btn-primary" style={{ fontSize:12, padding:'5px 12px' }} onClick={()=>setModal(true)}>+ Add User</button>
        </div>
        <table className="table">
          <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Change Role</th><th>Remove</th></tr></thead>
          <tbody>
            {users.map(u=>(
              <tr key={u.id}>
                <td style={{ fontWeight:500 }}>{u.name}</td>
                <td style={{ color:'#888', fontSize:12 }}>{u.email}</td>
                <td><span className={`tag ${RC[u.role]||'tag-gray'}`} style={{ textTransform:'capitalize' }}>{u.role}</span></td>
                <td>
                  <select value={u.role} onChange={e=>changeRole(u.id,e.target.value)}
                    style={{ border:'1px solid #ddd', borderRadius:6, padding:'3px 7px', fontSize:12 }}>
                    {ROLES.map(r=><option key={r} value={r}>{r}</option>)}
                  </select>
                </td>
                <td><button className="btn btn-danger" style={{ fontSize:11, padding:'3px 9px' }} onClick={()=>removeUser(u.id,u.name)}>Remove</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {modal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Add Staff User</h3>
            {[['name','Full Name','text','e.g. Rahul Kumar'],['email','Email','email','staff@vippizza.in'],['password','Password','password','min 6 chars']].map(([k,l,t,p])=>(
              <div className="field" key={k}><label>{l}</label>
                <input className="input" type={t} placeholder={p} value={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} />
              </div>
            ))}
            <div className="field"><label>Role</label>
              <select className="input" value={form.role} onChange={e=>setForm(f=>({...f,role:e.target.value}))}>
                {ROLES.map(r=><option key={r} value={r}>{r}</option>)}
              </select>
            </div>
            <div style={{ background:'#f8f8f8', borderRadius:8, padding:'9px 12px', fontSize:12, color:'#666', marginBottom:12 }}>
              <b>Access: </b>{PERM[form.role]}
            </div>
            <div style={{ display:'flex', gap:8 }}>
              <button className="btn" style={{ flex:1 }} onClick={()=>setModal(false)}>Cancel</button>
              <button className="btn btn-primary" style={{ flex:1 }} onClick={addUser} disabled={saving}>{saving?'Creating…':'Create User'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}